import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Loader from '../../../components/loader';
import Button from '../../../external/components/Button/Button';
import Icon from '../../../external/components/Icon/Icon';
import Text from '../../../external/components/Text/Text';
import networkHelpers from '../../../helpers/network.helpers';
import { State } from '../../../reducers';
import { useNakedStakingPool } from '../hooks/usePool';
import { useStakingData } from '../hooks/useStakingData';
import { StakingScreenEnum } from './_Screens';

interface Props {
  unstakeAmount: string;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setScreen: React.Dispatch<React.SetStateAction<StakingScreenEnum>>;
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  button + button {
    margin-left: 1rem;
  }
`;

export function UnstakeImmediatelySuccess({ unstakeAmount, setScreen, setShow }: Props) {
  const [loading, setLoading] = useState(false);
  const pool = useNakedStakingPool();

  const { networkId, stakingTokenSymbol, fee } = pool;

  const {
    getBalance: updateStakedBalance,
    getTokenBalance: updateTokenBalance,
    getUnstakes: updateUnstakes,
  } = useStakingData({
    pool,
  });

  const initData = async () => {
    try {
      setLoading(true);
      await updateStakedBalance();
      await updateTokenBalance();
      await updateUnstakes();
      setLoading(false);
    } catch (error) {
      //@FIX handle error
      setLoading(false);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  const { transactionId } = useSelector((state: State) => state.stakingPool);

  return (
    <>
      <StyledWrapper>
        {loading ? (
          <>
            <Loader />
            <Text dark={true} style={{ marginTop: '1rem' }}>
              Transaction confirmed, updating balances...
            </Text>
          </>
        ) : (
          <>
            <Icon type='doneDark' width={100}></Icon>

            <Text dark={true} style={{ margin: '0.5rem 0 0.15rem' }}>
              Unstaked
            </Text>
            <Text dark={true} size='lg' style={{ margin: '0.5rem 0' }}>
              {(parseFloat(unstakeAmount) * ((100 - fee) / 100)).toLocaleString('en-us', {
                minimumFractionDigits: 2,
              })}{' '}
              {stakingTokenSymbol}
            </Text>
            <Text dark={true} style={{ margin: '0.5rem 0 0.15rem' }}>
              Unstake fee
            </Text>
            <Text dark={true} size='xl' style={{ margin: '0.5rem 0' }} as='span'>
              {(parseFloat(unstakeAmount) * (fee / 100)).toLocaleString('en-us', {
                minimumFractionDigits: 2,
              })}{' '}
              {stakingTokenSymbol}
            </Text>
            <Text style={{ margin: '0.5rem 0' }} dark={true}>
              <a
                rel='noopener noreferrer'
                target='_blank'
                href={`${networkHelpers.findBlockExplorerUrl(networkId)}/tx/${transactionId}`}
              >
                View transction{' '}
                <Icon
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                  type='external'
                />
              </a>
            </Text>

            <StyledButtonContainer>
              <Button
                dark={true}
                variant='secondary'
                onClick={() => setScreen(StakingScreenEnum.HOME_SCREEN)}
              >
                View stake
              </Button>
              <Button dark={true} variant='secondary' onClick={() => setShow(false)}>
                Close
              </Button>
            </StyledButtonContainer>
          </>
        )}
      </StyledWrapper>
    </>
  );
}
